import { createAsyncThunk } from '@reduxjs/toolkit';
import { PromotionAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  ICreatePromotionDTO,
  IGetPromotionsListDTO,
  IUpdatePromotionDTO,
  TCreatePromotionResponse,
  TGetPromotionsListResponse,
  TUpdatePromotionResponse,
} from '@/models/promotion.model';
import { SLICE_NAME } from './models';

export const getCoupons = createAsyncThunk<
  TGetPromotionsListResponse,
  IGetPromotionsListDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getCoupons`,
  async (params) => {
    const response = await PromotionAPI.getPromotions(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateCoupon = createAsyncThunk<
  TUpdatePromotionResponse,
  IUpdatePromotionDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateCoupon`,
  async (data) => {
    const response = await PromotionAPI.updatePromotion(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createCoupon = createAsyncThunk<
  TCreatePromotionResponse,
  ICreatePromotionDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/createCoupon`,
  async (data) => {
    const response = await PromotionAPI.createPromotion(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
